"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const goal_condition_value_1 = require("./segment-behaviors/goal-condition.value");
const app_version_condition_value_1 = require("./segment-common/app-version-condition.value");
const carrier_condition_value_1 = require("./segment-common/carrier-condition.value");
const connection_condition_value_1 = require("./segment-common/connection-condition.value");
const device_model_condition_value_1 = require("./segment-technologies/device-model-condition.value");
const is_returning_condition_value_1 = require("./segment-common/is-returning-condition.value");
const language_condition_value_1 = require("./segment-common/language-condition.value");
const number_pageviews_condition_value_1 = require("./segment-behaviors/number-pageviews-condition.value");
const number_visits_condition_value_1 = require("./segment-common/number-visits-condition.value");
const os_version_condition_value_1 = require("./segment-technologies/os-version-condition.value");
const transaction_condition_value_1 = require("./segment-behaviors/transaction-condition.value");
const visit_duration_condition_value_1 = require("./segment-behaviors/visit-duration-condition.value");
exports.sdkSegmentConditions = [
    device_model_condition_value_1.deviceModelCondition,
    os_version_condition_value_1.osVersionCondition,
    app_version_condition_value_1.appVersionCondition,
    carrier_condition_value_1.carrierCondition,
    connection_condition_value_1.connectionCondition,
    is_returning_condition_value_1.isReturningCondition,
    language_condition_value_1.languageCondition,
    number_visits_condition_value_1.numberVisitsCondition,
    number_pageviews_condition_value_1.numberPageviewsCondition,
    transaction_condition_value_1.transactionCondition,
    visit_duration_condition_value_1.visitDurationCondition,
    goal_condition_value_1.goalCondition,
];
//# sourceMappingURL=index.js.map